import { createFileRoute, Navigate } from '@tanstack/react-router';

/**
 * Instructor Dashboard Page
 *
 * Route: /:locale/instructor/
 */
export const Route = createFileRoute('/$locale/_authenticated/instructor/')({
  component: InstructorDashboardRedirect,
});

function InstructorDashboardRedirect() {
  const { locale } = Route.useParams();
  return <Navigate to="/$locale/instructor/dashboard" params={{ locale }} replace />;
}
